import React from "react";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";

function DicomImage({ open, onClose, imageUrl }) {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent sx={{ height: "100%", padding: 0, position: "relative" }}>
        <Box
          sx={{
            position: "fixed",
            top: 10,
            right: 10,
            zIndex: 1,
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
          onClick={onClose}
        >
          <Typography
            sx={{
              color: "black",
              fontFamily: "TT-Norms, sans-serif",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
            }}
          >
            Close
          </Typography>
        </Box>
        <Box
          sx={{
            zIndex: 102,
            backgroundColor: "#000",
            borderRadius: "8px",
            maxWidth: "none",
            height: "100%",
            marginLeft: 0,
            marginRight: 0,
            display: "flex",
            width: "100%",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              flex: 1,
              justifyContent: "center",
              alignSelf: "stretch",
              alignItems: "stretch",
              display: "block",
              overflow: "hidden",
            }}
          >
            <iframe
              src={imageUrl}
              title="URL content"
              style={{
                height: "100%",
                width: "100%",
                overflowClipMargin: "content-box",
                overflow: "clip",
                borderWidth: "2px",
                borderStyle: "inset",
                borderColor: "initial",
                borderImage: "initial",
                margin: "0",
                boxSizing: "border-box",
              }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default DicomImage;
